import { Gender } from '../common/Gender';
import { User } from '../auth/User';

export abstract class PersonBase {

	public id: string;
	public slug: string;
	public firstName: string;
	public lastName: string;
	public middleName: string;
	public displayName: string;
	public nickName: string;
	public hometown: string;
	public description: string;
	public birthDate?: Date;
	public createdDate: Date;
	public updatedDate: Date;
	public gender: Gender;
	public genderId: number;
	public createdBy: User;
	public lastUpdatedBy: User;
	public isEnabled: boolean;
	public aosId: number;
	public birthYear?: number = null;
	public birthMonth?: number = null;
	public birthDay?: number = null;
	public deathYear?: number = null;
	public deathMonth?: number = null;
	public deathDay?: number = null;

}
